/**
 * @generated SignedSource<<1a9d46b91691af824c5b71c1ac123c6e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksHomepageMidPageRecommendationConfigQuery$data = {
  readonly homepageMidPageRecommendation: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "hooksHomepageMidPageRecommendationConfigQuery";
};
export type hooksHomepageMidPageRecommendationConfigQuery$key = {
  readonly " $data"?: hooksHomepageMidPageRecommendationConfigQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksHomepageMidPageRecommendationConfigQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksHomepageMidPageRecommendationConfigQuery",
  "selections": [
    {
      "alias": "homepageMidPageRecommendation",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "entityId": "homepage_mid_page_recommendation"
          }
        }
      ],
      "concreteType": "AppConfigs",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "json",
          "storageKey": null
        }
      ],
      "storageKey": "appConfig(filter:{\"entityId\":\"homepage_mid_page_recommendation\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "52b42fb366389e5f485f0db0f8e67d0c";

export default node;
